// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes pulse-data-v-38319aa3{50%{opacity:.5}}.empty[data-v-38319aa3]{display:flex;flex-direction:column;justify-content:center;align-items:center;height:100%;padding:16px;grid-gap:16px;gap:16px}.empty>p[data-v-38319aa3]{color:#7a7a7a;font-size:24px;font-weight:400}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
